/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { PrinterDto } from '@gh/builder-shared-data';

export type PrinterFinderListItem = PrinterDto;

export const getPrinterFinderListItemId = (printer: PrinterFinderListItem) => printer.cloudPrinterId;
